// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCommentForm_form__1OQ96","loading":"NewCommentForm_loading__3hZbG","control":"NewCommentForm_control__1Engr","actions":"NewCommentForm_actions__o2bby"};